module.exports = __webpack_public_path__ + "static/media/logo_white.46c34be6.svg";